<template>
    <el-container class="page-task-filter-list-container">
        <el-header>
            <!-- <Header></Header> -->
        </el-header>
        <el-main>
            <TaskFilterListTable :taskType="taskType"></TaskFilterListTable>
        </el-main>
        <el-footer>
            <Footer></Footer>
        </el-footer>
    </el-container>
</template>

<script type="text/ecmascript-6">
    import Header from '../common/Header'
    import Footer from '../common/Footer'
    import TaskFilterListTable from '../tables/TaskFilterListTable'
    import { mapGetters} from "vuex";

    export default {
        name: "TaskFilterListPage",
        data() {
            return {
                taskType: 2
            };
        },
        components: {
            Header,
            Footer,
            TaskFilterListTable
    
        },
        watch: {
            // 监听路由变化
            $route: {
                handler:  function (val, oldVal){
                console.log(val);
                console.log('==========___________',this.$route.query.fixed);
                },
                // 深度观察监听
                deep:  true
            }
        },
        mounted() {
            if(!localStorage.getItem('setWater')) {
                this.watermark()
            }
        },
        computed: {
           ...mapGetters(["username", "userid",]),
        },
        methods: {
            watermark(settings) {
                //默认设置
                var defaultSettings = {
                    watermark_txt: `上海荟医信息科技有限公司${this.username}${this.userid}`,
                    watermark_x: 10, //水印起始位置x轴坐标
                    watermark_y: 10, //水印起始位置Y轴坐标
                    watermark_rows: 4, //水印行数
                    watermark_cols: 8, //水印列数
                    watermark_x_space: 50, //水印x轴间隔
                    watermark_y_space: 150, //水印y轴间隔
                    watermark_color: '#666', //水印字体颜色
                    watermark_alpha: 0.10, //水印透明度
                    watermark_fontsize: '15px', //水印字体大小
                    watermark_font: '黑体', //水印字体
                    watermark_width: 180, //水印宽度
                    watermark_height: 80, //水印长度
                    watermark_angle: 20 //水印倾斜度数
                };
                if (arguments.length === 1 && typeof arguments[0] === "object") {
                    var src = arguments[0] || {};
                    for (key in src) {
                        if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) continue;
                        else if (src[key]) defaultSettings[key] = src[key];
                    }
                }
                var oTemp = document.createDocumentFragment();
                let element = document.querySelector('body')
                //获取页面最大宽度
                var page_width = Math.max(element.scrollWidth, element.clientWidth);
                var cutWidth = page_width * 0.0150;
                var page_width = page_width - cutWidth;
                //获取页面最大高度
                var page_height = Math.max(element.scrollHeight, element.clientHeight) + 450;
                page_height = Math.max(page_height, window.innerHeight - 30);
                //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
                if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
                    defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
                    defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
                }
                //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
                if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
                    defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
                    defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
                }
                var x;
                var y;
                for (var i = 0; i < defaultSettings.watermark_rows; i++) {
                    y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
                    for (var j = 0; j < defaultSettings.watermark_cols; j++) {
                        x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
                        var mask_div = document.createElement('div');
                        mask_div.id = 'mask_div' + i + j;
                        mask_div.className = 'mask_div';
                        mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
                        //设置水印div倾斜显示
                        mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
                        mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
                        mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
                        mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
                        mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
                        mask_div.style.visibility = "";
                        mask_div.style.position = "absolute";
                        mask_div.style.left = x + 'px';
                        mask_div.style.top = y + 'px';
                        mask_div.style.overflow = "hidden";
                        mask_div.style.zIndex = "9999";
                        //让水印不遮挡页面的点击事件
                        mask_div.style.pointerEvents = 'none';
                        mask_div.style.opacity = defaultSettings.watermark_alpha;
                        mask_div.style.fontSize = defaultSettings.watermark_fontsize;
                        mask_div.style.fontFamily = defaultSettings.watermark_font;
                        mask_div.style.color = defaultSettings.watermark_color;
                        mask_div.style.textAlign = "center";
                        mask_div.style.width = defaultSettings.watermark_width + 'px';
                        mask_div.style.height = defaultSettings.watermark_height + 'px';
                        mask_div.style.display = "block";
                        oTemp.appendChild(mask_div);
                    };
                };
                element.appendChild(oTemp);
                localStorage.setItem('setWater',true)
            },
        }
    };
</script>

<style scoped lang="scss">
    // 920px
    $height: calc(100vh - 60px - 60px);
    .page-task-filter-list-container {
        .el-main {
            //min-height: calc(100vh-96px-60px);
            height: $height;
            margin: 0px;
            padding: 0px;
            overflow: auto;
        }
    }
    
</style>
